export type RollingPerformanceConfig = {
  chartType: 'Automated' | 'Manual';
  periods: Array<{ label: string; value: number }>;
  isin: string;
  automationType: string;
  legend: Record<string, string>;
  barColorSets: string[];
};

const EMPTY_PERIODS: RollingPerformanceConfig['periods'] = [];
const EMPTY_LEGEND: RollingPerformanceConfig['legend'] = {};
const EMPTY_BAR_COLOR_SETS: RollingPerformanceConfig['barColorSets'] = [];

/**
 * SHV factsheets use the IT4Funds automated yearly bar chart by default.
 * Legacy documents often have chartType "Manual" with stale hard-coded periods (e.g. April dates).
 */
export function normalizeRollingPerformance(
  rollingPerformance: Partial<RollingPerformanceConfig> | null | undefined,
  templateIsin?: string,
): RollingPerformanceConfig {
  const isin = (rollingPerformance?.isin || templateIsin || '').trim();
  const base: RollingPerformanceConfig = {
    chartType: 'Automated',
    periods: EMPTY_PERIODS,
    isin,
    automationType: rollingPerformance?.automationType || 'gross_perf_year_as_of_today',
    legend: rollingPerformance?.legend || EMPTY_LEGEND,
    barColorSets: rollingPerformance?.barColorSets || EMPTY_BAR_COLOR_SETS,
  };

  if (
    rollingPerformance?.chartType === 'Manual' &&
    Array.isArray(rollingPerformance.periods) &&
    rollingPerformance.periods.length > 0
  ) {
    return {
      ...base,
      chartType: 'Manual',
      periods: rollingPerformance.periods,
      automationType: rollingPerformance.automationType || base.automationType,
      legend: rollingPerformance.legend || base.legend,
      barColorSets: rollingPerformance.barColorSets || base.barColorSets,
    };
  }

  // Automated or legacy manual periods → IT4Funds feed; never keep stale hard-coded periods.
  return base;
}
